import BaseService from "services/BaseService";
import _ from "lodash";

class WorkSpaceService extends BaseService {
    list = async () => {
        var data = await this._api.post("master/workspace/list",);
        return data;
    }

    packageList = async () => {
        return await this._api.post("master/workspace/packages");
    }

    renew = async ({ w_id, package_key, duration_months }) => {
        return await this._api.post("master/workspace/renew", { w_id, package_key, duration_months });
    }

    createDemo = async ({ shop_name }) => {
        return await this._api.post("master/workspace/create-demo", { shop_name });
    }

    detail = async ({ w_id }) => {
        return await this._api.post("master/workspace/detail", { w_id });
    }

    createSampleData = async ({ w_id, shop_description_prompt, reset_homepage = false }) => {
        return await this._api.post("master/workspace/create-sample-data", {
            w_id,
            shop_description_prompt,
            reset_homepage,
        });
    }

}
export default WorkSpaceService;
